<template>
  <div class="expired_wrapper">
    <div class="text_wrapper">
      <h2>Истек лимит времени</h2>
      <p>
        С момента начала прохождения прошло более 24 часов. Пожалуйста, начните тестирование заново.
        Чтобы обеспечить высокую точность и достоверность вашего ЭИ-профиля, завершите его в течение суток.
      </p>
    </div>
    <div>
      <a-button class="primary-button" @click="resumeExpiredPassing">
        Начать тестирование заново
      </a-button>
    </div>
  </div>
</template>

<script>
import {useStore} from "vuex";
import {computed} from "@vue/runtime-core";

export default {
  name: "TestExpired",
  setup(props, context) {
    const store = useStore();
    const passing = computed(() => store.state.test.currentPassing);
    const resumeExpiredPassing = () => {
      store.dispatch('test/resumeExpiredPassing', passing.value.code);
      context.emit("resumeExpired");
    }

    return {
      resumeExpiredPassing,
    }
  }
}
</script>

<style scoped lang="scss">
.testing-container .expired_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  text-align: left;

  h2 {
    font-size: 24px;
  }
}

.text_wrapper {
  font-size: 14px;
}

@media (max-width: $mobile-breakpoint) {
  .text_wrapper {
    font-size: 14px;
  }

  .primary-button {
    width: 100%;
  }
}
</style>